var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "setting-drawer" },
    [
      _c(
        "a-drawer",
        {
          style: {},
          attrs: {
            width: "300",
            placement: "right",
            closable: false,
            visible: _vm.visible,
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            { staticClass: "setting-drawer-index-content" },
            [
              _c("div", { style: { marginBottom: "24px" } }, [
                _c("h3", { staticClass: "setting-drawer-index-title" }, [
                  _vm._v("整体风格设置"),
                ]),
                _c(
                  "div",
                  { staticClass: "setting-drawer-index-blockChecbox" },
                  [
                    _c(
                      "a-tooltip",
                      [
                        _c("template", { slot: "title" }, [
                          _vm._v("\n              暗色菜单风格\n            "),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "setting-drawer-index-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleMenuTheme("dark")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/dark.svg"),
                                alt: "dark",
                              },
                            }),
                            _vm.navTheme === "dark"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "setting-drawer-index-selectIcon",
                                  },
                                  [_c("a-icon", { attrs: { type: "check" } })],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      2
                    ),
                    _c(
                      "a-tooltip",
                      [
                        _c("template", { slot: "title" }, [
                          _vm._v("\n              亮色菜单风格\n            "),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "setting-drawer-index-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleMenuTheme("light")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/light.svg"),
                                alt: "light",
                              },
                            }),
                            _vm.navTheme !== "dark"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "setting-drawer-index-selectIcon",
                                  },
                                  [_c("a-icon", { attrs: { type: "check" } })],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { style: { marginBottom: "24px" } }, [
                _c("h3", { staticClass: "setting-drawer-index-title" }, [
                  _vm._v("主题色"),
                ]),
                _c(
                  "div",
                  { staticStyle: { height: "20px" } },
                  _vm._l(_vm.colorList, function (item, index) {
                    return _c(
                      "a-tooltip",
                      {
                        key: index,
                        staticClass: "setting-drawer-theme-color-colorBlock",
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.key) +
                              "\n            "
                          ),
                        ]),
                        _c(
                          "a-tag",
                          {
                            attrs: { color: item.color },
                            on: {
                              click: function ($event) {
                                return _vm.changeColor(item.color)
                              },
                            },
                          },
                          [
                            item.color === _vm.primaryColor
                              ? _c("a-icon", { attrs: { type: "check" } })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                  1
                ),
              ]),
              _c("a-divider"),
              _c("div", { style: { marginBottom: "24px" } }, [
                _c(
                  "div",
                  { style: { marginTop: "24px" } },
                  [
                    _c(
                      "a-list",
                      { attrs: { split: false } },
                      [
                        _c(
                          "a-list-item",
                          [
                            _c("a-switch", {
                              attrs: {
                                slot: "actions",
                                size: "small",
                                defaultChecked: _vm.fixedHeader,
                              },
                              on: { change: _vm.handleFixedHeader },
                              slot: "actions",
                            }),
                            _c("a-list-item-meta", [
                              _c(
                                "div",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v("固定 Header")]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "a-list-item",
                          [
                            _c("a-switch", {
                              attrs: {
                                slot: "actions",
                                size: "small",
                                disabled: !_vm.fixedHeader,
                                defaultChecked: _vm.autoHideHeader,
                              },
                              on: { change: _vm.handleFixedHeaderHidden },
                              slot: "actions",
                            }),
                            _c("a-list-item-meta", [
                              _c(
                                "div",
                                {
                                  style: {
                                    textDecoration: !_vm.fixedHeader
                                      ? "line-through"
                                      : "unset",
                                  },
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [_vm._v("下滑时隐藏 Header")]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "a-list-item",
                          [
                            _c("a-switch", {
                              attrs: {
                                slot: "actions",
                                size: "small",
                                disabled: _vm.layoutMode === "topmenu",
                                checked: _vm.fixSiderbar,
                              },
                              on: { change: _vm.handleFixSiderbar },
                              slot: "actions",
                            }),
                            _c("a-list-item-meta", [
                              _c(
                                "div",
                                {
                                  style: {
                                    textDecoration:
                                      _vm.layoutMode === "topmenu"
                                        ? "line-through"
                                        : "unset",
                                  },
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [_vm._v("固定侧边菜单")]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("a-divider"),
              _c("div", { style: { marginBottom: "24px" } }, [
                _c("h3", { staticClass: "setting-drawer-index-title" }, [
                  _vm._v("语言设置"),
                ]),
                _c("div", { staticStyle: { padding: "10px 0 50px 0" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        float: "left",
                        width: "40%",
                        "line-height": "30px",
                      },
                    },
                    [_vm._v(_vm._s(_vm.langSetTitle))]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { float: "left", width: "60%" },
                      attrs: { id: "langSetting" },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: {
                            placeholder: "请选择语言",
                            showSearch: "",
                            optionFilterProp: "children",
                            value: _vm.currentLang,
                          },
                          on: { change: _vm.handleChangeLang },
                        },
                        [
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "chinese_simplified" },
                            },
                            [_vm._v("简体中文")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "chinese_traditional" },
                            },
                            [_vm._v("繁體中文")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "english" },
                            },
                            [_vm._v("English")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "korean" },
                            },
                            [_vm._v("한국어")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "japanese" },
                            },
                            [_vm._v("しろうと")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "vietnamese" },
                            },
                            [_vm._v("Tiếng Việt")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "hindi" },
                            },
                            [_vm._v("हिन्दी")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "russian" },
                            },
                            [_vm._v("Русский язык")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "french" },
                            },
                            [_vm._v("Français")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "ukrainian" },
                            },
                            [_vm._v("УкраїнськаName")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "norwegian" },
                            },
                            [_vm._v("Norge")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "welsh" },
                            },
                            [_vm._v("color name")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "dutch" },
                            },
                            [_vm._v("nederlands")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "filipino" },
                            },
                            [_vm._v("Pilipino")]
                          ),
                          _c(
                            "a-select-option",
                            { staticClass: "ignore", attrs: { value: "lao" } },
                            [_vm._v("ກະຣຸນາ")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "telugu" },
                            },
                            [_vm._v("తెలుగుQFontDatabase")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "romanian" },
                            },
                            [_vm._v("Română")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "nepali" },
                            },
                            [_vm._v("नेपालीName")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "haitian_creole" },
                            },
                            [_vm._v("Kreyòl ayisyen")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "czech" },
                            },
                            [_vm._v("český")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "swedish" },
                            },
                            [_vm._v("Svenska")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "malagasy" },
                            },
                            [_vm._v("Malagasy")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "burmese" },
                            },
                            [_vm._v("ဗာရမ်")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "pashto" },
                            },
                            [_vm._v("پښتوName")]
                          ),
                          _c(
                            "a-select-option",
                            { staticClass: "ignore", attrs: { value: "thai" } },
                            [_vm._v("คนไทย")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "armenian" },
                            },
                            [_vm._v("Արմենյան")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "persian" },
                            },
                            [_vm._v("Persian")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "kurdish" },
                            },
                            [_vm._v("Kurdî")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "turkish" },
                            },
                            [_vm._v("Türkçe")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "bulgarian" },
                            },
                            [_vm._v("български")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "malay" },
                            },
                            [_vm._v("Malay")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "swahili" },
                            },
                            [_vm._v("Kiswahili")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "oriya" },
                            },
                            [_vm._v("ଓଡିଆ")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "icelandic" },
                            },
                            [_vm._v("ÍslandName")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "irish" },
                            },
                            [_vm._v("Íris")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "khmer" },
                            },
                            [_vm._v("ខ្មែរKCharselect unicode block name")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "gujarati" },
                            },
                            [_vm._v("ગુજરાતી")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "slovak" },
                            },
                            [_vm._v("Slovenská")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "kannada" },
                            },
                            [_vm._v("ಕನ್ನಡ್Name")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "hebrew" },
                            },
                            [_vm._v("היברית")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "hungarian" },
                            },
                            [_vm._v("magyar")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "marathi" },
                            },
                            [_vm._v("मराठीName")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "tamil" },
                            },
                            [_vm._v("தாமில்")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "estonian" },
                            },
                            [_vm._v("eesti keel")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "malayalam" },
                            },
                            [_vm._v("മലമാലം")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "inuktitut" },
                            },
                            [_vm._v("ᐃᓄᒃᑎᑐᑦ")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "arabic" },
                            },
                            [_vm._v("بالعربية")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "deutsch" },
                            },
                            [_vm._v("Deutsch")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "slovene" },
                            },
                            [_vm._v("slovenščina")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "bengali" },
                            },
                            [_vm._v("বেঙ্গালী")]
                          ),
                          _c(
                            "a-select-option",
                            { staticClass: "ignore", attrs: { value: "urdu" } },
                            [_vm._v("اوردو")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "azerbaijani" },
                            },
                            [_vm._v("azerbaijani")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "portuguese" },
                            },
                            [_vm._v("português")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "samoan" },
                            },
                            [_vm._v("lifiava")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "afrikaans" },
                            },
                            [_vm._v("afrikaans")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "tongan" },
                            },
                            [_vm._v("汤加语")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "greek" },
                            },
                            [_vm._v("ελληνικά")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "indonesian" },
                            },
                            [_vm._v("IndonesiaName")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "spanish" },
                            },
                            [_vm._v("Español")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "danish" },
                            },
                            [_vm._v("dansk")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "amharic" },
                            },
                            [_vm._v("amharic")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "punjabi" },
                            },
                            [_vm._v("ਪੰਜਾਬੀName")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "albanian" },
                            },
                            [_vm._v("albanian")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "lithuanian" },
                            },
                            [_vm._v("Lietuva")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "italian" },
                            },
                            [_vm._v("italiano")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "maltese" },
                            },
                            [_vm._v("Malti")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "finnish" },
                            },
                            [_vm._v("suomi")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "catalan" },
                            },
                            [_vm._v("català")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "croatian" },
                            },
                            [_vm._v("hrvatski")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "bosnian" },
                            },
                            [_vm._v("bosnian")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "polish" },
                            },
                            [_vm._v("Polski")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "latvian" },
                            },
                            [_vm._v("latviešu")]
                          ),
                          _c(
                            "a-select-option",
                            {
                              staticClass: "ignore",
                              attrs: { value: "maori" },
                            },
                            [_vm._v("Maori")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("a-divider"),
              _c("div", { style: { marginBottom: "24px" } }, [
                _c("h3", { staticClass: "setting-drawer-index-title" }, [
                  _vm._v("其他设置"),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "a-list",
                      { attrs: { split: false } },
                      [
                        _c(
                          "a-list-item",
                          [
                            _c("a-switch", {
                              attrs: {
                                slot: "actions",
                                size: "small",
                                defaultChecked: _vm.colorWeak,
                              },
                              on: { change: _vm.onColorWeak },
                              slot: "actions",
                            }),
                            _c("a-list-item-meta", [
                              _c(
                                "div",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v("色弱模式")]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm.visible
            ? _c(
                "div",
                {
                  staticClass: "setting-drawer-index-handle",
                  on: { click: _vm.toggle },
                },
                [_c("a-icon", { attrs: { type: "close" } })],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }